export default "__VITE_ASSET__B4qMILD5__"